module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/ygabn-logo.1b78b.png";